import styles from "./FilterHeader.module.css";
import PropTypes from "prop-types";

/**
 * Displays information about the currently selected filter.
 */
export function FilterHeader({ icon, title, count }) {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>{icon}</div>

      <h3 className={styles.title}>{title}</h3>

      <span className={styles.count}>({count})</span>
    </div>
  );
}

FilterHeader.propTypes = {
  /**
   * Element to serve as the icon.
   */
  icon: PropTypes.node,

  /**
   * Title text.
   */
  title: PropTypes.string.isRequired,

  /**
   * Number of records in this section.
   */
  count: PropTypes.number,

  /**
   * Display loading indictator instead of count if true.
   */
  loading: PropTypes.bool,
};
